import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { getUserName, getUserInitials } from "../utils/userInfo";
import { authService } from "../services/authService";
import MainFeed from "../components/MainFeed";
import NewRightPanel from "../components/NewRightPanel";

const LinkedInDashboard = () => {
  const [employee, setEmployee] = useState(null);

  const userName = getUserName();
  const userInitials = getUserInitials();

  const userProfile = employee
    ? {
        name: employee.employee_name,
        role: employee.designation_id,
        team: employee.department_name,
        company: employee.company_id,
        email: employee.office_email,
        location: employee.location_id,
        reportingTo: employee.reporting_to,
        client: employee.client,
        city: employee.city_id,
        state: employee.state_id,
        permanentCity: employee.permanent_city_id,
        permanentState: employee.permanent_state_id,
        googleEmail: employee.google_email,
        employeeCode: employee.employee_code,
        gender: employee.gender,
        dateOfBirth: employee.date_of_birth,
        joiningDate: employee.joining_date,
      }
    : {
        name: userName,
        role: "Analyst",
        team: "Delivery Team",
      };

  useEffect(() => {
    async function fetchEmployee() {
      try {
        const data = await authService.getCurrentEmployee();
        setEmployee(data);
        localStorage.setItem("employee", JSON.stringify(data));
      } catch (error) {
        console.error("Failed to fetch employee:", error);
      }
    }
    fetchEmployee();
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 12, md: 8 }}>
        <MainFeed
          userName={userName}
          userInitials={userInitials}
          userProfile={userProfile}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }} height={"100vh"} backgroundColor={"#f44336"}>
        <NewRightPanel />
      </Grid>
    </Grid>
  );
};

export default LinkedInDashboard;
